// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-7UeegX2l clearfix","businessNewAd1":"businessNewAd1-3k2O6hVd","throughColumnAd1":"throughColumnAd1-1d07tSV8"};